export default function Historia() {
  return (
    <div>
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <img src="https://images.pexels.com/photos/19250418/pexels-photo-19250418.jpeg" alt="Cocina tradicional" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-6 h-full flex flex-col justify-end pb-12 text-white">
          <div className="text-xs uppercase tracking-[0.25em] text-orange-300 mb-3">Nuestra historia</div>
          <h1 className="font-display text-5xl md:text-7xl font-black tracking-tight leading-[0.95]">Más que una taquería,<br />una tradición.</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 py-20 md:py-28 space-y-6 text-lg leading-relaxed text-zinc-700">
        <p className="text-2xl md:text-3xl font-display font-semibold text-zinc-900 leading-snug">
          En el corazón de San Cristóbal Ecatepec, J.R. Tacos El Paisa nació con una sola misión: servir el sabor de antes con la calidez de la familia.
        </p>
        <p>Carne de primera, marinadas que reposan toda la noche, salsas que recordamos de la casa de la abuela. No usamos trucos: usamos tiempo, atención y respeto por los ingredientes.</p>
        <p>Cada trompo se prepara con paciencia. Cada tortilla se calienta al momento. Cada cliente que entra es bienvenido como un viejo amigo. Esa es la fórmula que llevamos años perfeccionando, y la que queremos compartir contigo.</p>
        <p>Hoy, junto a la familia que nos ha visto crecer, seguimos haciendo tacos como antes: bien hechos, bien servidos, y con todo el corazón.</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-24 grid md:grid-cols-3 gap-4">
        {[
          { url: "https://images.pexels.com/photos/34109691/pexels-photo-34109691.jpeg", title: "El barrio" },
          { url: "https://images.pexels.com/photos/14758354/pexels-photo-14758354.jpeg", title: "Las noches" },
          { url: "https://images.pexels.com/photos/8448068/pexels-photo-8448068.jpeg", title: "La carne" },
        ].map((g, i) => (
          <div key={i} className="relative aspect-[4/5] rounded-3xl overflow-hidden group">
            <img src={g.url} alt={g.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute bottom-6 left-6 text-white font-display text-2xl font-black">{g.title}</div>
          </div>
        ))}
      </section>
    </div>
  );
}
